import { render, staticRenderFns } from "./show-view-detail.vue?vue&type=template&id=2df7cafc&"
import script from "./show-view-detail.vue?vue&type=script&lang=js&"
export * from "./show-view-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports